module.exports = __webpack_public_path__ + "static/media/floor_ns.86f47450.png";